import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api.service';
import { ContaPagarReceberResponseDTO } from '../../models/dashboard/conta-pagar-receber.model';
import { TotaisContasDTO } from '../../models/dashboard/totais-contas.model';
import { TituloResponseDTO } from '../../models/dashboard/titulo.model';

@Injectable({ providedIn: 'root' })
export class ContasPagarReceberService {

  constructor(private apiService: ApiService) {}

  buscarContasAgrupadas(params: {
    page: number;
    tipoOperacaoFinanceira: 'ENTRADA' | 'SAIDA';
    dataHoraInicial: string;
    dataHoraFinal: string;
    situacao?: 'ABERTO' | 'PAGO' | 'CANCELADO';
    nomePessoa?: string;
    conta?: number;
    pessoaId?: number;
  }): Observable<ContaPagarReceberResponseDTO> {
    const parts: string[] = [
      `page=${params.page}`,
      `tipoOperacaoFinanceira=${params.tipoOperacaoFinanceira}`,
      `dataHoraInicial=${params.dataHoraInicial}`,
      `dataHoraFinal=${params.dataHoraFinal}`,
    ];
    if (params.situacao) parts.push(`situacao=${params.situacao}`);
    if (params.nomePessoa) parts.push(`nomePessoa=${params.nomePessoa}`);
    if (params.conta) parts.push(`conta=${params.conta}`);
    if (params.pessoaId) parts.push(`pessoaId=${params.pessoaId}`);

    const query = parts.join('&');
    return this.apiService.read<ContaPagarReceberResponseDTO>(
      `/titulos/contasAReceberERecebidasAgrupadas?${query}`
    );
  }

  buscarTitulos(params: {
    page: number;
    size?: number;
    tipoOperacaoFinanceira: 'ENTRADA' | 'SAIDA';
    dataHoraInicial: string;
    dataHoraFinal: string;
    situacao?: 'ABERTO' | 'PAGO' | 'CANCELADO';
    nomePessoa?: string;
    conta?: number;
    pessoaId?: number;
    observacao?: string;
    sort?: string;
  }): Observable<TituloResponseDTO> {
    const parts: string[] = [
      `page=${params.page}`,
      `tipoOperacaoFinanceira=${params.tipoOperacaoFinanceira}`,
      `dataHoraInicial=${params.dataHoraInicial}`,
      `dataHoraFinal=${params.dataHoraFinal}`,
    ];
    if (params.size) parts.push(`size=${params.size}`);
    if (params.situacao) parts.push(`situacao=${params.situacao}`);
    if (params.nomePessoa) parts.push(`nomePessoa=${encodeURIComponent(params.nomePessoa)}`);
    if (params.conta) parts.push(`conta=${params.conta}`);
    if (params.pessoaId) parts.push(`pessoaId=${params.pessoaId}`);
    if (params.observacao) parts.push(`observacao=${encodeURIComponent(params.observacao)}`);
    if (params.sort) parts.push(`sort=${params.sort}`);

    const query = parts.join('&');
    return this.apiService.read<TituloResponseDTO>(
      `/titulos/buscar?${query}`
    );
  }

  buscarTotais(params: {
    dataHoraInicial: string;
    dataHoraFinal: string;
    tipoOperacaoFinanceira?: 'ENTRADA' | 'SAIDA';
    situacao?: 'ABERTO' | 'PAGO' | 'CANCELADO';
    nomePessoa?: string;
    conta?: number;
    pessoaId?: number;
    observacao?: string;
  }): Observable<TotaisContasDTO> {
    const parts: string[] = [
      `dataHoraInicial=${params.dataHoraInicial}`,
      `dataHoraFinal=${params.dataHoraFinal}`,
    ];
    if (params.tipoOperacaoFinanceira) parts.push(`tipoOperacaoFinanceira=${params.tipoOperacaoFinanceira}`);
    if (params.situacao) parts.push(`situacao=${params.situacao}`);
    if (params.nomePessoa) parts.push(`nomePessoa=${encodeURIComponent(params.nomePessoa)}`);
    if (params.conta) parts.push(`conta=${params.conta}`);
    if (params.pessoaId) parts.push(`pessoaId=${params.pessoaId}`);
    if (params.observacao) parts.push(`observacao=${encodeURIComponent(params.observacao)}`);

    const query = parts.join('&');
    return this.apiService.read<TotaisContasDTO>(
      `/titulos/totalContasAReceberAPagarERecebidas?${query}`
    );
  }

}
